import { render, staticRenderFns } from "./PagesFaqArticlesItem.vue?vue&type=template&id=a2d6dcd4&scoped=true&"
import script from "./PagesFaqArticlesItem.vue?vue&type=script&lang=js&"
export * from "./PagesFaqArticlesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d6dcd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VCard,VInput})
